module.exports = __webpack_public_path__ + "img/event2.96b02684.png";